import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  GeneralTable,
} from "@/shared/components/ui";
import { Badge, Grid, IconButton, Tooltip } from "@mui/material";
import {
  gridSizeMdLg5,
  ModulosEnumChoice,
  ModulosMotivoENUM,
  PRIORIDAD_INCIDENCIA_CHOICE,
  TABLE_CONSTANTS,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import ThreePOutlinedIcon from "@mui/icons-material/ThreePOutlined";
import { useEffect, useState } from "react";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import {
  EstadoBitacoraEnum,
  IDataBitacoraResp,
  Venta,
} from "@/shared/interfaces";
import { useTableColumnsBitacora } from "./useTableColumnsBitacora";
import { useFetchMotivos } from "@/shared/actions/erp";
import { IDataMotivo } from "@/shared/interfaces/erp/inventario/motivo.interface";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { useForm } from "react-hook-form";
import { Refresh } from "@mui/icons-material";

interface TableBitacoraComponente {
  prioridad: string;
  motivo: string;
}

interface TableBitacoraComponenteProps {
  estado_bitacora: EstadoBitacoraEnum;
  enable_action: boolean;
  disabledAction?: boolean
}
interface DiccionarioMotivo {
  fase_venta?: string;
}

export default function TableBitacoraComponentePyl({
  estado_bitacora,
  enable_action = true,
  disabledAction = false
}: TableBitacoraComponenteProps) {


  const [dataBitacora, setDataBitacora] = useState<IDataBitacoraResp | null>(
    null
  );
  const [detalleDiccionarioMotivo, setDetalleMotivo] = useState<
    DiccionarioMotivo[]
  >([]);

  const form = useForm<TableBitacoraComponente>();

  const {
    formState: { errors },
  } = form;

  const {
    sorting,
    setSorting,
    pagination,
    setPagination
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* socket
  const { emitGetVentaById, setOpen, setFaseVenta, socket } =
    useDiccionarioMotivo();

  const {
    data: dataMotivos,
    isLoading: isLoadingMotivo
  } = useFetchMotivos({
    estado: true,
    modulo_in: `${ModulosMotivoENUM.BITACORA_VENTA},${ModulosMotivoENUM.BITACORA_PYL}`,
    page_size: 256,
  });

  const numero_referencia_motivo = form.watch("motivo");
  const prioridad = form.watch("prioridad");

  useEffect(() => {
    if (!socket) return;

    handleVentas();

    socket.on("getVentas", (response: IDataBitacoraResp) => {
      if (response.code == 200) {
        setDataBitacora(response);
      }
    });

    return () => {
      socket.off("getVentas");
    };
  }, [
    socket,
    pageIndex,
    pageSize,
    filterObject,
    numero_referencia_motivo,
    prioridad,
    sorting,
  ]);

  useEffect(() => {
    if (!detalleDiccionarioMotivo || detalleDiccionarioMotivo.length === 0)
      return;

    // Mapeo de las fases de venta a constantes
    const fasesPrioritarias = [
      ModulosEnumChoice.RECORDINADO,
      ModulosEnumChoice.AGENDAMIENTO,
      ModulosEnumChoice.PREAGENDAMIENTO,
      ModulosEnumChoice.PREVENTA,
    ];

    // Encontrar la primera fase que coincida
    const faseEncontrada = fasesPrioritarias.find((fase) =>
      detalleDiccionarioMotivo.some((item) => item.fase_venta === fase)
    );

    if (faseEncontrada) {
      setFaseVenta(faseEncontrada);
    }
  }, [detalleDiccionarioMotivo]);

  const handle = (value: any) => {
    setDetalleMotivo(value.diccionario_motivo);
  };

  const handleVentas = () => {
    if (!socket) return;

    const primarySort = sorting[0];

    let ordenamiento = {}
    if (primarySort) {
      ordenamiento = {
        sortBy: primarySort.id,
        sortDir: primarySort.desc ? "desc" : "asc",
      }
    }

    console.log(ordenamiento);
    
    socket.emit("getVentasFilter", {
      page: pageIndex + 1,
      pageSize: pageSize,
      filtros: {
        numero_referencia_motivo: numero_referencia_motivo,
        prioridad: prioridad,
        estado_bitacora,
        ...ordenamiento,
        ...filterObject,
      },
    });
  };


  const {
    columnsBitacoraPyl
  } = useTableColumnsBitacora({
    handle,
    disabledAction
  });


  return (
    <Grid container spacing={2}>
      <CustomAutocomplete<IDataMotivo>
        label="Motivo"
        name="motivo"
        // options
        options={dataMotivos?.data.data || []}
        valueKey="nombre"
        actualValueKey="id_motivo"
        defaultValue={form.getValues().motivo || ""}
        isLoadingData={isLoadingMotivo}
        // validation
        control={form.control}
        error={errors.motivo}
        helperText={errors.motivo?.message}
        size={gridSizeMdLg5}
        required={false}
      />

      <CustomAutocompleteArrString
        label="Prioridad"
        name="prioridad"
        options={PRIORIDAD_INCIDENCIA_CHOICE}
        control={form.control}
        defaultValue={form.getValues().prioridad || ""}
        error={errors.prioridad}
        helperText={errors.prioridad?.message?.toString() ?? ""}
        isLoadingData={false}
        size={gridSizeMdLg5}
        required={false}
      />

      <Grid item xs={2}>
        <IconButton
          onClick={() => {
            form.reset({});
          }}
        >
          <FilterAltOffIcon />
        </IconButton>

        <IconButton
          onClick={() => {
            //form.reset({})
            handleVentas();
          }}
        >
          <Refresh />
        </IconButton>
      </Grid>

      <Grid item xs={12}>
        <GeneralTable<Venta>
          data={dataBitacora?.data.data || []}
          columns={columnsBitacoraPyl}
          isLoading={false}
          isRefetching={false}
          enableGlobalFilter={false}
          ///* pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataBitacora?.data.count}
          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          positionActionsColumn="first"
          canDelete={false}
          canEdit={false}
          enableEditing={enable_action}
          ///* ordenar
          manualSorting={true}
          enableSorting={true}
          sorting={sorting}
          onSortingChange={setSorting}
          //
          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
          showCustomActionBtnSpace={enable_action}
          customActionBtnSpace={(value) => {
            return (
              <Grid container>
                <Grid item>
                  <Tooltip placement="top" title="Sin responder">

                    <IconButton
                      onClick={() => {
                        handle(value)
                        setOpen(true)
                        emitGetVentaById(value.numero_referencia_venta)
                      }}
                    >
                      <Badge
                        variant="standard"
                        color="primary"
                        badgeContent={value.contado}
                      //invisible={value.contado != 0 ? false : true}
                      >
                        <ThreePOutlinedIcon />
                      </Badge>
                    </IconButton>

                  </Tooltip>
                </Grid>
              </Grid>
            );
          }}
        />
      </Grid>
    </Grid>
  );
}
